import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Typography,
  Zoom,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import MoadalOldUI from "./ModalOldUI";
import moment from "moment";
import AppointmentModal from "../Structure/AppointmentModal";
import Autocomplete from "react-google-places-autocomplete";
import { useTranslation } from "react-i18next";
import MainButton from "./Buttons/MainButton";
import MainButtonApp from "./Buttons/MainButtonApp";

function Carusel({
  callNow,
  callLater,
  key,
  Appointment_object,
  setAppointment_object,
}) {
  // 1) Data
  const timeOut = useRef(null);
  const wipe = useRef(null);
  const { t } = useTranslation();
  const ApplicationSettings = useSelector(
    (state) => state.ApplicationSettings.value
  );
  const [buttonsArray, setbuttonsArray] = useState([]);
  const [buttonsIndex, setbuttonsIndex] = useState(0);
  const [carTypesArray, setcarTypesArray] = useState([]);
  const [Extra_Destinations_Array, setExtra_Destinations_Array] = useState([]);
  const [carTypesIndex, setcarTypesIndex] = useState(0);
  const [fade, setfade] = useState(true);
  const [showModal, setshowModal] = useState(false);
  const [showModalOldUI, setshowModalOldUI] = useState(false);
  const [callDestinationSelection, setcallDestinationSelection] = useState("");
  const [callPriceSelection, setcallPriceSelection] = useState("");
  ///
  const [newUIcallType, setnewUIcallType] = useState(false);
  const [appointmentDesination, setappointmentDesination] = useState("");
  const [appointmentDate, setappointmentDate] = useState(
    moment().format("D MMMM YYYY")
  );
  const [dateValidation, setdateValidation] = useState(false);
  const [timeValidation, settimeValidation] = useState(false);
  const [appointmentTime, setappointmentTime] = useState(moment());
  const [pedikoKathisma, setpedikoKathisma] = useState(0);
  const [comment, setcomment] = useState("");
  const [canStoreAppointment, setcanStoreAppointment] = useState(false);
  const [appointmetObject, setappointmetObject] = useState({});
  const [customerName, setcustomerName] = useState("");
  const [moreDestinations, setMoreDestinations] = useState(false);
  const [moreDestinationsIndex, setmoreDestinationsIndex] = useState(0);
  const [CallDestination, setCallDestination] = useState("");
  const [showAppointmentModal, setshowAppointmentModal] = useState(false);
  const [paymentType, setPaymentType] = useState(false);

  // 2) Carusel Functions and Effects
  useEffect(() => {
    if (!fade) {
      clearTimeout(timeOut.current);
      timeOut.current = setTimeout(() => {
        setfade(true);
      }, 300);
    }
    return;
  }, [fade]);

  useEffect(() => {
    let extra = ApplicationSettings.Extra_Destinations_Array;
    let btns = ApplicationSettings.ButtonsArray;
    let vt = ApplicationSettings.CarTypesArray;
    if (btns != null && btns !== undefined) {
      setbuttonsArray(btns);
      setappointmentDesination(
        ApplicationSettings.ButtonsArray[buttonsIndex].name
      );
    }
    if (vt != null && vt !== undefined) {
      setcarTypesArray(vt);
    }
    if (extra != null && extra !== undefined) {
      setExtra_Destinations_Array(extra);
    }

    return;
  }, []);

  useEffect(() => {
    AppointmentCheck();
    return;
  }, [
    appointmentTime,
    appointmentDesination,
    appointmentDate,
    comment,
    pedikoKathisma,
    carTypesIndex,
    paymentType,
    customerName,
  ]);

  // 3) Function
  const AppointmentCheck = () => {
    let timeCheck = checkAppointmentTime();

    settimeValidation(timeCheck);
    var formattedTime = initialize_app_time();
    let vehType = ApplicationSettings.CarTypesArray[carTypesIndex].code;

    let pedikoKathisma_completed =
      pedikoKathisma === 0 || pedikoKathisma === "0" ? "" : pedikoKathisma;

    if (appointmentDesination.length > 0 && !dateValidation && !timeCheck) {
      //console.log("EISAI EDW MESA");
      let new_appointment_object = {
        destination: appointmentDesination,
        date: appointmentDate,
        time: formattedTime,
        pedikoKathisma: pedikoKathisma_completed,
        comment: comment,
        vehicleType: vehType,
        customerName: customerName,
      };

      if (paymentType) {
        new_appointment_object.vehicleType =
          vehType + ApplicationSettings.Code_for_POS;
        new_appointment_object.paymentMethod = 2;
        //console.log("EISAI EDW MESA 2");
      }
      let vehTypeName = ApplicationSettings.CarTypesArray[carTypesIndex].name;

      let vehTypeSendEmail =
        ApplicationSettings.CarTypesArray[carTypesIndex].sendEmail;
      // console.log("vehTypeSendEmail :", vehTypeSendEmail);

      if (vehTypeName !== "TAXI") {
        new_appointment_object.vehicleType +=
          ApplicationSettings.Car_Type_Code_To_Show_Hotel;
      }

      //sendmail
      if (vehTypeSendEmail) {
        new_appointment_object.sendEmail = true;
      } else {
        new_appointment_object.sendEmail = false;
      }

      //console.log("Appointment Object from Carusel :", new_appointment_object);

      setappointmetObject(new_appointment_object);
      setcanStoreAppointment(true);
    } else {
      setcanStoreAppointment(false);
    }
  };

  const handleChangeAppointmentDate = (newValue) => {
    let d = moment(newValue).format("D MMMM YYYY");
    setappointmentDate(d);
    checkAppointmentDate(newValue);
  };

  const checkAppointmentDate = (value) => {
    let now = moment();
    now.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    let date = moment(value);
    if (value !== null) {
      if (moment(value).isSameOrAfter(now)) {
        setdateValidation(false);
      }
    } else {
      setdateValidation(true);
    }
  };

  const checkAppointmentTime = () => {
    let now = moment().startOf("day").utcOffset(0).unix();
    let date = moment(appointmentDate).startOf("day").utcOffset(0).unix();
    let time = appointmentTime;

    let reservationAfter3Hours =
      ApplicationSettings.CarTypesArray[carTypesIndex].after3hours;

    //Check if  in every type of taxi except TAXI, appointment must be at least 3 hours later
    if (reservationAfter3Hours) {
      if (date == now) {
        if (time !== null) {
          if (time.isSameOrAfter(moment().add(3, "hours"))) {
            settimeValidation(false);
            return false;
          } else {
            settimeValidation(true);
            return true;
          }
        }
      } else {
        settimeValidation(true);
        return false;
      }
    } else {
      if (date == now) {
        if (time !== null) {
          if (time.isSameOrAfter(moment())) {
            settimeValidation(false);
            return false;
          } else {
            settimeValidation(true);
            return true;
          }
        }
      } else {
        settimeValidation(true);
        return false;
      }
    }
  };

  const handleChangeAppointmentTime = (newValue) => {
    setappointmentTime(newValue);
  };

  const CallNowTextDestination = () => {
    //console.log("Destination Button Clicked");
    setcallDestinationSelection(CallDestination);
    setcallPriceSelection("-");
    setshowModalOldUI(true);
  };

  const initialize_app_time = () => {
    let timeObject = appointmentTime.toObject();
    var hours = timeObject.hours;
    var minutes = timeObject.minutes;
    return hours + ":" + minutes + ":00";
  };

  // Blocks
  const TaxiBlock = ({ data, index }) => {
    return (
      <div
        onClick={() => {
          setbuttonsIndex(index);
          if (index !== 3) {
            setshowModalOldUI(true);
            setcallDestinationSelection(buttonsArray[index].name);
            setcallPriceSelection(buttonsArray[index].prices[0]);
            setMoreDestinations(false);
            setCallDestination("");
          } else {
            setMoreDestinations(true);
            setmoreDestinationsIndex(-1);
          }
        }}
      >
        <MainButton data={data} buttonsIndex={buttonsIndex} index={index} />
      </div>
    );
  };

  const CarTypeBlock = ({ data, index }) => {
    return (
      <div
        className={
          carTypesIndex === index
            ? "type-block  text-base cursor-pointer Primary_Dark_Background Primary_Light_Text"
            : "type-block  text-base cursor-pointer taxi-block-background Primary_Dark_Text"
        }
        onClick={() => setcarTypesIndex(index)}
      >
        <div className="bg-gradient-to-t from-gray-100 p-3  rounded-full ">
          <img
            src={data.imageUrl}
            className={
              buttonsIndex === index
                ? "w-8 sm:w-10 md:w-12  Primary_Light_Text"
                : "w-8 sm:w-10 md:w-12 Primary_Dark_Text"
            }
          />
        </div>

        <div className="taxi-destination text-white">{data.name}</div>
      </div>
    );
  };

  const MoreDestinationsBlock = ({ data, index }) => {
    return (
      <div
        className="type-block text-base cursor-pointer taxi-block-background Primary_Dark_Text"
        onClick={() => {
          setmoreDestinationsIndex(index);
          setcallDestinationSelection(Extra_Destinations_Array[index].name);
          setcallPriceSelection(
            Extra_Destinations_Array[index].prices[0].price
          );
          setCallDestination("");
          setshowModalOldUI(true);
        }}
      >
        <div className="taxi-destination text-white">{data.name}</div>
      </div>
    );
  };

  const MoreDestinationsBlockForAppointment = ({ data, index }) => {
    return (
      <div
        className={
          moreDestinationsIndex === index
            ? "type-block  cursor-pointer Primary_Dark_Background Primary_Light_Text h-24 w-5/6  "
            : "type-block  cursor-pointer taxi-block-background Primary_Dark_Text  h-24 w-5/6 "
        }
        onClick={() => {
          setmoreDestinationsIndex(index);
          setappointmentDesination(Extra_Destinations_Array[index].name);
          setbuttonsIndex(3);
        }}
      >
        <div className="taxi-destination text-white">{data.name}</div>
      </div>
    );
  };

  const TaxiBlockForAppointment = ({ data, index }) => {
    return (
      <div
        onClick={() => {
          setbuttonsIndex(index);
          if (index !== 3) {
            setMoreDestinations(false);
            setappointmentDesination(buttonsArray[index].name);
          } else {
            setMoreDestinations(true);
            setappointmentDesination("");
            setmoreDestinationsIndex(-1);
          }
        }}
      >
        <MainButtonApp data={data} buttonsIndex={buttonsIndex} index={index} />
      </div>
    );
  };

  return (
    <>
      {/* Header */}
      <div className="text-center mt-3">
        <p className=" text-3xl  Primary_Main_Text">{t("CALL_A_VEHICLE")}</p>
      </div>

      {/* Buttons */}
      <div className="flex justify-center items-center w-full mb-5 mt-5 ">
        <div className="mr-2">
          <div
            className={
              !newUIcallType
                ? "Primary_Dark_Background font-semibold Primary_Light_Text px-4 py-1 rounded-full text-xl shadow hover:shadow-lg cursor-pointer"
                : "Primary_Dark_Text font-semibold Primary_Light_Text px-4 py-1 rounded-full text-xl shadow hover:shadow-lg cursor-pointer border"
            }
            onClick={() => {
              setnewUIcallType(false);
              setbuttonsIndex(0);
              setMoreDestinations(false);
              setcallDestinationSelection(buttonsArray[0].name);
              setcallPriceSelection(buttonsArray[0].price);
              setappointmentDesination("");
              setCallDestination("");
            }}
          >
            {t("NOW")}
          </div>
        </div>
        <div className="ml-2">
          <div
            className={
              newUIcallType
                ? "Primary_Dark_Background font-semibold Primary_Light_Text px-4 py-1 rounded-full text-xl shadow hover:shadow-lg cursor-pointer"
                : "Primary_Dark_Text border font-semibold Primary_Light_Text px-4 py-1 rounded-full text-xl shadow hover:shadow-lg cursor-pointer"
            }
            onClick={() => {
              setnewUIcallType(true);
              setbuttonsIndex(0);
              setappointmentDesination(buttonsArray[0].name);
              setMoreDestinations(false);
              setmoreDestinationsIndex(0);
            }}
          >
            {t("LATER")}
          </div>
        </div>
      </div>

      {/* Blocks */}
      {!newUIcallType ? (
        <>
          <div className="flex flex-wrap justify-center">
            {buttonsArray.map((data, index) => (
              <div className="mx-2 my-2">
                <TaxiBlock key={index + "t2"} data={data} index={index} />
              </div>
            ))}
          </div>

          {!moreDestinations && (
            <div className="md:max-w-3xl m-auto mt-2 p-3">
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <TextField
                    id="outlined-basic"
                    label={t("Customer_Name")}
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={customerName}
                    inputProps={{ style: { fontSize: 16 } }}
                    onChange={(type) => setcustomerName(type.target.value)}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <TextField
                    id="outlined-basic"
                    label={t("Comment")}
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={comment}
                    inputProps={{ style: { fontSize: 16 } }}
                    onChange={(type) => setcomment(type.target.value)}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  {ApplicationSettings.ShowPOS && (
                    <FormControlLabel
                      control={
                        paymentType ? (
                          <>
                            <Checkbox
                              defaultChecked
                              value={paymentType}
                              onChange={() => setPaymentType(false)}
                            />
                          </>
                        ) : (
                          <Checkbox
                            value={paymentType}
                            onChange={() => setPaymentType(true)}
                          />
                        )
                      }
                      label={t("POS_Payment")}
                    />
                  )}
                </Grid>
              </Grid>
            </div>
          )}

          {moreDestinations && (
            <>
              <div className="grid grid-cols-3 gap-3 md:grid-cols-4 place-items-center max-w-sm md:max-w-3xl m-auto">
                {Extra_Destinations_Array.map((data, index) => {
                  return (
                    <MoreDestinationsBlock
                      key={index + "k2"}
                      data={data}
                      index={index}
                    />
                  );
                })}
              </div>
              <div className="md:max-w-3xl m-auto py-3 px-3">
                <Grid container spacing={2}>
                  <Grid item xs={7}>
                    <Autocomplete
                      apiKey={key}
                      className="z-40"
                      //onPlaceSelected={handleSelect}
                      ref={wipe}
                      autocompletionRequest={{
                        componentRestrictions: {
                          country: ["gr"], //to set the specific country
                        },
                      }}
                      apiOptions={{
                        language: "gr",
                        region: "gr",
                      }}
                      selectProps={{
                        placeholder: t("Address"),
                        appointmentDesination,
                        onChange: (selected) => {
                          setCallDestination(selected.label);
                          //console.log("Selected :", selected);
                          setbuttonsIndex(3);
                          setmoreDestinationsIndex(-1);
                        },
                      }}
                      minLengthAutocomplete={4}
                      onLoadFailed={(error) => {
                        console.log("Error on Places :", error);
                      }}
                    />
                  </Grid>
                  <Grid item xs={5} md={5}>
                    <TextField
                      id="outlined-basic"
                      label={t("Customer_Name")}
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={customerName}
                      inputProps={{ style: { fontSize: 16 } }}
                      onChange={(type) => setcustomerName(type.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <TextField
                      id="outlined-basic"
                      placeholder={t("Comment")}
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={comment}
                      inputProps={{ style: { fontSize: 16 } }}
                      onChange={(type) => setcomment(type.target.value)}
                    />
                  </Grid>
                  <Grid item xs={7} md={7}>
                    {ApplicationSettings.ShowPOS && (
                      <FormControlLabel
                        control={
                          paymentType ? (
                            <>
                              <Checkbox
                                defaultChecked
                                value={paymentType}
                                onChange={() => setPaymentType(false)}
                              />
                            </>
                          ) : (
                            <Checkbox
                              value={paymentType}
                              onChange={() => setPaymentType(true)}
                            />
                          )
                        }
                        label={t("POS_Payment")}
                      />
                    )}
                  </Grid>

                  <Grid item xs={5}>
                    {CallDestination.length > 0 ? (
                      <>
                        <Typography
                          onClick={() => CallNowTextDestination()}
                          className="Primary_Main_Background p-2 text-center rounded-full text-white shadow hover:shadow-lg hover:shadow-gray-400 hover:scale-105 cursor-pointer active:scale-95"
                        >
                          {t("CALL")}
                        </Typography>
                      </>
                    ) : (
                      <>
                        <Typography className="bg-gray-300 p-2 text-center rounded-full text-gray-500 shadow cursor-pointer">
                          {t("CALL")}
                        </Typography>
                      </>
                    )}
                  </Grid>
                </Grid>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          {/* Button Block */}
          <div className="grid grid-cols-2 gap-2 md:grid-cols-4 place-items-center max-w-sm md:max-w-3xl m-auto">
            {buttonsArray.map((data, index) => (
              <TaxiBlockForAppointment
                key={index + "z2"}
                data={data}
                index={index}
              />
            ))}
          </div>
          {moreDestinations && (
            <>
              <div className="grid gap-0 grid-cols-4 place-items-center max-w-xl  m-auto">
                {Extra_Destinations_Array.map((data, index) => {
                  return (
                    <MoreDestinationsBlockForAppointment
                      key={index + "q2"}
                      data={data}
                      index={index}
                    />
                  );
                })}
              </div>
            </>
          )}

          {/* Blocks */}
          <div className="max-w-3xl Primary_Main_Text text-center m-auto font-semibold text-lg mt-3">
            <p> {t("VEHICLE_SELETION")}</p>
          </div>
          <div className="grid grid-cols-3 gap-3 md:grid-cols-5 place-items-center max-w-sm md:max-w-3xl m-auto">
            {carTypesArray.map((data, index) => {
              return (
                <CarTypeBlock key={index + "l2"} data={data} index={index} />
              );
            })}
          </div>

          {/* Date Inputs */}
          <div className="md:max-w-3xl m-auto mt-2 p-3">
            <Grid container spacing={2}>
              <Grid item xs={8} md={6} style={{ zIndex: 100 }}>
                {buttonsIndex === -1 ||
                (buttonsIndex == 3 && moreDestinationsIndex == -1) ? (
                  <>
                    {/* <div>{appointmentDesination}</div> */}
                    <Autocomplete
                      apiKey={key}
                      className="z-10"
                      forcePopupIcon={false}
                      //onPlaceSelected={handleSelect}
                      ref={wipe}
                      apiOptions={{
                        language: "gr",
                        region: "gr",
                      }}
                      autocompletionRequest={{
                        componentRestrictions: {
                          country: ["gr"], //to set the specific country
                        },
                      }}
                      selectProps={{
                        placeholder: t("Address"),
                        appointmentDesination,
                        onChange: (selected) => {
                          setappointmentDesination(selected.label);
                          setbuttonsIndex(-1);
                          setMoreDestinations(false);
                        },
                      }}
                      minLengthAutocomplete={4}
                      onLoadFailed={(error) => {
                        console.log("Error on Places :", error);
                      }}
                    />
                    {appointmentDesination.length == 0 && (
                      <div className="text-red-600">
                        {t("Address is required*")}
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {" "}
                    <TextField
                      onClick={() => {
                        setbuttonsIndex(-1);
                        setMoreDestinations(false);
                        setappointmentDesination("");
                      }}
                      inputProps={{ style: { fontSize: 16 } }}
                      value={appointmentDesination}
                      onChange={(type) =>
                        setappointmentDesination(type.target.value)
                      }
                      error={appointmentDesination.length == 0}
                      id="outlined-basic"
                      label={t("Address")}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />{" "}
                  </>
                )}
              </Grid>
              <Grid item xs={4} md={2}>
                <MobileDatePicker
                  label={t("Date")}
                  inputFormat="MM/DD/YYYY"
                  value={appointmentDate}
                  onChange={handleChangeAppointmentDate}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      error={dateValidation}
                      //inputRef={DateFromInput}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3} md={2}>
                <TimePicker
                  label={t("Time")}
                  ampm={false}
                  value={appointmentTime}
                  onChange={handleChangeAppointmentTime}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      error={timeValidation}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3} md={2}>
                <TextField
                  inputProps={{ style: { fontSize: 16 } }}
                  id="outlined-basic"
                  type="number"
                  label={t("Kid's_seat")}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={pedikoKathisma}
                  onChange={(type) => setpedikoKathisma(type.target.value)}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <TextField
                  id="outlined-basic"
                  label={t("Comment")}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={comment}
                  inputProps={{ style: { fontSize: 16 } }}
                  onChange={(type) => setcomment(type.target.value)}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <TextField
                  id="outlined-basic"
                  label={t("Customer_Name")}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={customerName}
                  inputProps={{ style: { fontSize: 16 } }}
                  onChange={(type) => setcustomerName(type.target.value)}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                {ApplicationSettings.ShowPOS && (
                  <FormControlLabel
                    control={
                      paymentType ? (
                        <>
                          <Checkbox
                            defaultChecked
                            value={paymentType}
                            onChange={() => setPaymentType(false)}
                          />
                        </>
                      ) : (
                        <Checkbox
                          value={paymentType}
                          onChange={() => setPaymentType(true)}
                        />
                      )
                    }
                    label={t("POS_Payment")}
                  />
                )}
              </Grid>
            </Grid>
          </div>

          {/* Call Button */}
          {canStoreAppointment ? (
            <>
              <div
                className="my-3  flex justify-center"
                onClick={() => {
                  //callLater(appointmetObject);
                  setshowAppointmentModal(true);
                  // setnewUIcallType(false);
                  // setappointmentDesination("");
                  // setpedikoKathisma(0);
                  // setcomment("");
                  // setcustomerName("");
                }}
              >
                <Typography className="Primary_Main_Background p-3 rounded-full text-white shadow hover:shadow-lg hover:shadow-gray-400 hover:scale-105 cursor-pointer active:scale-95">
                  {t("REGISTER_APPOINTMENT")}
                </Typography>
              </div>
            </>
          ) : (
            <>
              <div className="my-3  flex justify-center">
                <Typography className="bg-gray-300 p-3 rounded-full text-gray-500 shadow cursor-pointer ">
                  {t("REGISTER_APPOINTMENT")}
                </Typography>
              </div>
            </>
          )}
        </>
      )}

      {/* Other Options */}
      {ApplicationSettings.ShowBanner && (
        <div className="max-w-3xl m-auto">
          <div className="flex justify-center  mb-4 mt-1 md:mt-10 m-auto">
            <div className=" ">
              <img
                className="object-contain h-28 w-96  "
                src={
                  process.env.PUBLIC_URL +
                  "/Images/" +
                  ApplicationSettings.server_name +
                  "/Banner.png"
                }
              />
            </div>
          </div>
        </div>
      )}

      {/* Modal */}
      {showModalOldUI && (
        <>
          <MoadalOldUI
            showModal={showModalOldUI}
            setshowModal={setshowModalOldUI}
            destination={callDestinationSelection}
            price={callPriceSelection}
            callNow={callNow}
            callLater={callLater}
            customerName={customerName}
            setcustomerName={setcustomerName}
            comment={comment}
            setcomment={setcomment}
            paymentType={paymentType}
            setPaymentType={setPaymentType}
          />
        </>
      )}
      {showAppointmentModal && (
        <>
          <AppointmentModal
            showModal={showAppointmentModal}
            setshowModal={setshowAppointmentModal}
            destination={appointmentDesination}
            object={appointmetObject}
            callLater={callLater}
            setappointmentDesination={setappointmentDesination}
            setappointmentDate={setappointmentDate}
            setappointmentTime={setappointmentTime}
            setpedikoKathisma={setpedikoKathisma}
            setcomment={setcomment}
            setcustomerName={setcustomerName}
            setbuttonsIndex={setbuttonsIndex}
            setcarTypesIndex={setcarTypesIndex}
            setMoreDestinations={setMoreDestinations}
            paymentType={paymentType}
            setPaymentType={setPaymentType}
          />
        </>
      )}
    </>
  );
}

export default Carusel;
